import { render, staticRenderFns } from "./allocation-list.vue?vue&type=template&id=1433f8fa&scoped=true"
import script from "./allocation-list.vue?vue&type=script&lang=js"
export * from "./allocation-list.vue?vue&type=script&lang=js"
import style0 from "./allocation-list.vue?vue&type=style&index=0&id=1433f8fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1433f8fa",
  null
  
)

export default component.exports